module.exports = __webpack_public_path__ + "img/1574154341.615eabdb.jpg";